import Star from './Star';
import Logo from './Logo';
import Checked from './Checked';
import Dotted from './Dotted';
import Trash from './Trash';
import TrustIcon from './TrustIcon';
import GoogleTrust from './GoogleTrust';
import DownloadIcon from './DownloadIcon';
import CalendarIcon from './CalendarIcon';
import GoogleIcon from './GoogleIcon';
import FacebookIcon from './FacebookIcon';
import PartnerIcon from './PartnerIcon';
import PartnerLogo from './PartnerLogo';
import TrustCertificates from './TrustCertificates';

export {
  Star,
  Logo,
  Trash,
  Checked,
  Dotted,
  TrustIcon,
  DownloadIcon,
  GoogleTrust,
  CalendarIcon,
  GoogleIcon,
  FacebookIcon,
  PartnerIcon,
  PartnerLogo,
  TrustCertificates,
};
